<script>
  /* global agGrid */
  import GRID_LOCALE_CS from '../../js/gridLocaleCs.js';
  import GRID_LOCALE_EN from '../../js/gridLocaleEn.js';
  import { onMount } from 'svelte';

  export let value;
  export let lang = undefined;
  export let mode = undefined;

  let gameStatisticsPlayersElement;

  let gridOptions;

  function getOptions () {
    return {
      theme: 'legacy',
      defaultColDef: {
        cellDataType: 'number',
        type: 'numericColumn',
        width: 56.25,
        sortable: false,
        filter: false,
      },
      columnDefs: [
        {
          headerName: lang !== 'en' ? 'Hráč' : 'Player',
          // eslint-disable-next-line no-magic-numbers
          openByDefault: window.innerWidth > 1200 || (window.innerWidth <= 1000 && window.innerWidth > 800),
          children: [
            {
              field: 'spot',
              headerName: '##',
              width: 45,
              cellDataType: 'number',
              type: 'numericColumn',
              pinned: true,
              valueFormatter: params => params.value || '',
            },
            {
              field: 'lastName',
              headerName: lang !== 'en' ? 'Příjmení' : 'Last name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              cellStyle: { fontWeight: 'bold' },
            },
            {
              field: 'firstName',
              headerName: lang !== 'en' ? 'Jméno' : 'First name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              columnGroupShow: 'open',
            },
            {
              field: 'positions',
              headerName: lang !== 'en' ? 'Poz.' : 'Pos.',
              headerTooltip: lang !== 'en' ? 'Pozice' : 'Positions',
              width: 67.5,
              cellDataType: 'text',
              type: [],
              pinned: true,
              columnGroupShow: 'open',
              valueFormatter: params => params.value.join(' / '),
            },
          ],
        },
        {
          field: 'batting.avg',
          headerName: 'AVG',
          headerTooltip: 'Batting average',
          width: 67.5,
          valueFormatter: params => params.value.toFixed(3),
        },
        {
          field: 'batting.pa',
          headerName: 'PA',
          headerTooltip: 'Plate appearance',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.ab',
          headerName: 'AB',
          headerTooltip: 'At bat',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.r',
          headerName: 'R',
          headerTooltip: 'Run',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.h',
          headerName: 'H',
          headerTooltip: 'Hit',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.2b',
          headerName: '2B',
          headerTooltip: 'Double',
        },
        {
          field: 'batting.3b',
          headerName: '3B',
          headerTooltip: 'Triple',
        },
        {
          field: 'batting.hr',
          headerName: 'HR',
          headerTooltip: 'Home run',
        },
        {
          field: 'batting.gdp',
          headerName: 'GDP',
          headerTooltip: 'Grounded into double play',
        },
        {
          field: 'batting.sh',
          headerName: 'SH',
          headerTooltip: 'Sacrifice bunt',
        },
        {
          field: 'batting.sf',
          headerName: 'SF',
          headerTooltip: 'Sacrifice fly',
        },
        {
          field: 'batting.bb',
          headerName: 'BB',
          headerTooltip: 'Walk',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.hp',
          headerName: 'HP',
          headerTooltip: 'Hit by pitch',
        },
        {
          field: 'batting.sb',
          headerName: 'SB',
          headerTooltip: 'Stolen base',
        },
        {
          field: 'batting.cs',
          headerName: 'CS',
          headerTooltip: 'Caught stealing',
        },
        {
          field: 'batting.k',
          headerName: 'K',
          headerTooltip: 'Strikeout',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'batting.rbi',
          headerName: 'RBI',
          headerTooltip: 'Runs batted in',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'fielding.po',
          headerName: 'PO',
          headerTooltip: 'Putout',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'fielding.a',
          headerName: 'A',
          headerTooltip: 'Assist',
        },
        {
          field: 'fielding.e',
          headerName: 'E',
          headerTooltip: 'Error',
        },
        {
          field: 'fielding.dp',
          headerName: 'DP',
          headerTooltip: 'Double play',
        },
        {
          field: 'fielding.pb',
          headerName: 'PB',
          headerTooltip: 'Passed ball',
        },
        {
          field: 'fielding.sb',
          headerName: 'SB',
          headerTooltip: 'Stolen base',
        },
        {
          field: 'fielding.cs',
          headerName: 'CS',
          headerTooltip: 'Caught stealing',
        },
        {
          flex: 1,
          filter: false,
          sortable: false,
          suppressMovable: true,
        },
      ],
      animateRows: true,
      tooltipShowDelay: 500,
      domLayout: 'autoHeight',
      rowData: value,
      localeText: lang !== 'en' ? GRID_LOCALE_CS : GRID_LOCALE_EN,
    };
  }

  onMount(() => {
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(gameStatisticsPlayersElement, gridOptions);
  });

  $: if (gridOptions && lang) {
    gridOptions.api.destroy();
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(gameStatisticsPlayersElement, gridOptions);
  }
</script>

<div class='game-statistics-players ag-theme-balham' bind:this={gameStatisticsPlayersElement}
  class:ag-theme-balham-dark={mode !== 'light'}/>

<style>
  .game-statistics-players {
    width: 100%;
    height: 100%;
  }

  :global(.ag-root-wrapper) {
    border-radius: 5px;
  }
</style>
